import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';

import '../../styles/global.css';

export default function Layout() {
    return (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
        </>
    );
}
